import { ConfigurationRepositoryConfigurationAdminService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationAdminService'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation } from '@tanstack/react-query'

type InputArguments = {
  branchName: string
  baseBranchName: string
  server: ConfigurableServer
}

export const useForcePushBranchToBaseBranch = () =>
  useMutation({
    mutationFn: async ({ branchName, server }: InputArguments) => {
      await ConfigurationRepositoryConfigurationAdminService.configurationAdminServicePostForcePushBranch(
        {
          requestBody: {
            _type: 'BranchCommandSpecification',
            branchName,
            componentName: server.toLocaleLowerCase(),
          },
        },
      )
    },
  })
